<div style="height: 100%">
  <monorepo-bctx-selection
    [header]="header"
    [bctxList]="bctxList"
    [orderKeys]="orderKeysToDisplay"
    (onBctxSelection)="handleBctxSelection($event)"
    (onClose)="handleClose()"
    (onSync)="handleSync()"
    [bctxKeysToDisplayMap]="bctxKeysToDisplayMap"
    [bctxKeysToFilterTitles]="bctxKeysToFilterTitles"
    [selectedBctxItem]="selectedBctxItem"
    [buttonTxt]="buttonTxt"
    [enableProceed]="true"
  >
  </monorepo-bctx-selection>
</div>

<ng-template #ErrorMessage>{{ 'packing_bctx_selection.error_message1' | translate }}</ng-template>
<ng-template #ErrorMessage2>{{ 'packing_bctx_selection.error_message2' | translate }}</ng-template>
